import React from "react";

import { Link } from "react-router-dom";


import Card2 from '../card/card2';
import Card3 from "../card/card3";
const ARTICLEDATA = [
    {
        id: "1",
        title: "چگونه درامد بیشترداشته باشیم",
        desctiption1: "به عنوان یک فریلنسر، دانستن این موضوع که روی یک پروژه چقدر قیمت بگذارید می‌تواند حسی مانند شرط بندی باشد.",
        description: "برنامه نویس بودن می تواند برای هر کسی فوق العاده باشد. در این شغل نه تنها شما اکثر مواقع سرگرم هستید بلکه فرصت های شغلی زیادی برای شما وجود دارد که اکثر آنها نیز دارای حقوق و درآمد بالایی هستند. با این حال برخی از مواقع ممکن است شما نیاز به درآمد بیشتری داشته باشید. ممکن است شما در دوران تحصیل خود باشید و به جای این که در یک شرکت استخدام شوید علاقه مند هستید تا به عنوان یک برنامه نویس برای خودتان کار کنید یا این که ممکن است یک فرزند داشته باشید و علاقه مند باشید تا زمان بیشتری را با او بگذرانید و به همین علت نمی توانید در شرکت ها کار کنید و باید برای خودتان کار کنید. شما به عنوان یک برنامه نویس هرآنچه که برای افزایش درآمد نیاز دارید را در اختیار دارید. مغزتان، لپ تاپ و اینترنت تنها چیزهایی هستند که شما به آنها نیاز دارید. برای افزایش درآمد برنامه نویسی می توانید استراتژی هایی که در ادامه بیان می کنیم را بررسی کنید تا متوجه شوید که کدام یک می توانند برای شما گزینه بهتری باشند.",
        image: "images/course9.jpg"
    },
    {
        id: "2",
        title: "نکاتی برای ساخت نمونه کارهای عالی ",
        desctiption1: "هنگام درخواست کار، شرکت‌ها نگاهی به نمونه کارهای شما دارند. حتی اگر به صورت فریلنسری هم کار می‌کنید مشتری شما دوست ",
        description: "به عنوان یک توسعه دهنده می‌توانید به صورت فریلنسر کار کنید. اگر دانشجو هستید، به درآمدزایی شما کمک می‌کند و به شما در ارتقاء مهارت‌هایتان کمک می‌کند. با پروژه‌های کوچک شروع کنید، آن‌ها را به درستی انجام دهید. پس از اطمینان کافی از خود، به ساخت پروژه‌هایی در حد متوسط و پیشرفته بپردازید. فریلنسرینگ قطعا به نمونه کارهای شما ارزش می‌دهد. پروژه‌هایی که به عنوان فریلنسر ساخته شده‌اند، اعتماد به نفس و تخصص شما در آن مهارت را نشان می‌دهد.",
        image: "images/course6.jpg"
    },
    {
        id: "3",
        title: "چگونه یک توسعه دهنده پر بازده باقی بمانیم",
        desctiption1: "شما چه در حال حاضر یک توسعه دهنده باتجربه باشید یا تازه شروع به کار کرده باشید، اگر می‌خواهید در این صنعت واقعا موفق باشید،",
        description: "شما باید نه گفتن را به عنوان یک توسعه دهنده بیاموزید. بله گفتن به برخی از افراد در برخی از موارد به خصوص زمانی که شخص درخواست کننده را از نظر اجتماعی می شناسید کار نادرستی است. اگر مراقب این مسئله نباشید این کار می تواند به میزان زیادی روی بهره وری شما تاثیرگذار باشد. گاهی اوقات انجام کارهای کمتر بسیار کارآمدتر از زمانی است که حجم زیادی از کارها را با عجله انجام دهید. زمانی که کارها را با عجله انجام دهید نسبت به مهلت اتمام پروژه ها عقب می افتید و این مسئله می تواند به میزان زیادی باعث خسته شدن شما شود. بنابراین شما باید یاد بگیرید که چگونه نه بگویید. این کار به شما کمک می کند تا پیشاپیش درباره برنامه ها و اولویت های خود تصمیم گیری کنید و به شکل بهتری آنها را سازماندهی کنید.",
        image: "images/im4.jpg"

    },


];

const Course = ({ courses }) => {


    return (

        <section className="terms-items">

            <header>
                <h2> آخرین دوره های ماه کورس </h2><br></br>

            </header>

            <div className="row">

                {
                    courses?.map(course => {
                        return (
                            <div className="col-lg-3 col-md-4 col-sm-6 col-xs-12 term-col" key={course._id} >
                                <article>
                                    <Link to={`/course/${course._id}`} className="img-layer">
                                        <img
                                            style={{ height: "180px" }}
                                            src={`https://toplearnapi.ghorbany.dev/${course.imageUrl}`} />
                                    </Link>
                                    <h2>
                                        <a href="">
                                            {course.title}
                                        </a>
                                    </h2>
                                    <span> {course.price == 0 ? "رایگان" :

                                        ` ${course.price} تومان`} </span>
                                    <i>1:52:32</i>
                                </article>
                            </div>
                        )
                    })
                }


            </div>
            <header>
                <h2> جدیدترین مقالات </h2>

            </header>

            <Card3 meetups={ARTICLEDATA} />


            <header>
                <h2> مدرسین  </h2>

            </header>
            <Card2 />


        </section>
    );
};

export default Course;
